import { produce } from 'immer'
import {
  CLEAR_COGNITO_CHANGE_PASSWORD_ERRORS,
  POST_COGNITO_CHANGE_PASSWORD_FAILURE,
  POST_COGNITO_CHANGE_PASSWORD_INIT,
  POST_COGNITO_CHANGE_PASSWORD_SUCCESS,
  PostCognitoChangePasswordActions,
} from 'src/app/ChangePassword/redux/changePassword.actions'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface ChangePasswordState {
  loading: boolean
  changePasswordTopLevelError?: string
  changePasswordErrorDetailMap?: ErrorDetailMap<string>
}

export const initialState: ChangePasswordState = {
  loading: false,
}

export type Actions = PostCognitoChangePasswordActions

const ChangePasswordReducer = (
  state = initialState,
  action: Actions,
): ChangePasswordState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_COGNITO_CHANGE_PASSWORD_INIT: {
        draft.loading = true
        return draft
      }

      case POST_COGNITO_CHANGE_PASSWORD_SUCCESS: {
        draft.loading = false
        return draft
      }

      case POST_COGNITO_CHANGE_PASSWORD_FAILURE: {
        const errors = parseBackendErrors(action.payload)

        draft.loading = false
        draft.changePasswordTopLevelError = errors.topLevelError
        draft.changePasswordErrorDetailMap = errors.errorDetailMap
        return draft
      }

      case CLEAR_COGNITO_CHANGE_PASSWORD_ERRORS: {
        draft.changePasswordTopLevelError = undefined
        draft.changePasswordErrorDetailMap = undefined
        return draft
      }
    }
  })
}

export default ChangePasswordReducer
